<template>
  <div class="bg">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "450px"
    },
    direction: {
      type: String,
      default: "right"
    }
  }
};
</script>

<style lang="stylus" scoped>
.bg
  background url('~@/assets/images/comp/span.png')
  width 100%
  height 100%
</style>



// WEBPACK FOOTER //
// src/components/vBg.vue